define('ordersDetailDocumentsCustomerView',[
  'app',
  'module',
  'underscore',
  'settings',
  'attachmentsView',
  'entities/orders'
], function(
  App,
  Module,
  _,
  Settings,
  AttachmentsView
) {
  'use strict';

  Module.exports = AttachmentsView.extend({

    setConfig() {
      return {
        galleryTitle: 'Customer Documents',
        canCopy: Settings.configValue('order.attachments.showCustomerAttachments') ? true : false,
        copyButton: {
          title: _.i18n('orders.detail.attachments.customer.copy-button.title')
        },
        canAiEdit: true
      };
    },

    aiEditItem: function(attachment) {
      this.openAiEditChat(this.options.order.get('purchaseOrderId'), attachment);
    },

    fetch: function(first, pageSize) {
      return this.model.getDocuments(first, pageSize);
    },

    uploadItem: function(file) {
      return this.model.uploadDocument(file);
    },

    deleteItem(attachment) {
      return this.model.deleteDocument(attachment);
    },

    editItem: function(attachment) {
      App.navigate('attachments/attachments/' + this.model.get('secId') + '/' + attachment.get('secId') + '/customer', {trigger: true});
    },

    copyItem: function(attachment) {
      this.model.copyDocumentToOrder(attachment, this.options.order.get('purchaseOrderId')).done(_.bind(function(newAttachment) {
        var model = App.request('order:model', newAttachment);
        this.options.documentsView.orderView.addAttachment(model);
      }, this));
    }
  });
});

